<!--
 * @Author: Gaho
 * @Date: 2024-02-26 15:53:04
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-17 16:39:44
 * @Description: 各种类型卡片渲染
-->
<template>
    <div
        class="corgiwild-wrapper-card"
        ref="card"
        :class="{ 'corgiwild-wrapper-card-win': index === 36 && isWin }"
    >
        <component
            v-if="cardsComponent[section]"
            :is="cardsComponent[section]"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
// components
import Card7 from '../cards/7.vue';
import CardWild from '../cards/wild.vue';
import CardSingle from '../cards/single.vue';
import CardDouble from '../cards/double.vue';
import CardTriple from '../cards/triple.vue';
import CardCherry from '../cards/cherry.vue';

export default defineComponent({
    name: 'corgiwild-cards',
    components: {
        Card7,
        CardWild,
        CardSingle,
        CardDouble,
        CardTriple,
        CardCherry,
    },
    props: {
        section: {
            type: Number,
            default: 0,
        },
        index: {
            type: Number,
            default: 0,
        },
        isWin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cardsComponent: {
                1: markRaw(CardWild),
                2: markRaw(Card7),
                3: markRaw(CardSingle),
                4: markRaw(CardDouble),
                5: markRaw(CardTriple),
                6: markRaw(CardCherry)
            }
        };
    }
});
</script>

<style lang="scss">
.corgiwild-wrapper-card {
    background: #5638b22e;
    border: 2px solid rgba(113, 78, 217, 0.29);
    border-radius: 20px;
    margin-bottom: 7px;
    position: relative;
    width: 100%;
    min-width: 90px;
    min-height: 90px;

    &::after {
        content: '';
        display: block;
        padding-bottom: 100%;
    }

    @media (max-width: 576px) {
        margin-bottom: 5px;
    }
}
.corgiwild-wrapper-card .card-bg {
    background: #5638b273;
    border-radius: 14px;
    bottom: 7px;
    display: flex;
    left: 7px;
    overflow: hidden;
    position: absolute;
    right: 7px;
    top: 7px;

    @media (max-width: 576px) {
        bottom: 5px;
        left: 5px;
        right: 5px;
        top: 5px;
    }

    svg {
        color: #cd3fff;
        height: 100%;
        width: 100%;
    }

    .card-bg-img {
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-45%, -45%) scale(1);
        z-index: 2;
        max-height: 90%;

        @media (max-width: 576px) {
            max-height: 90%;
        }
    }

    .card-bg-img-double {
        left: 50%;
        position: absolute;
        top: 40%;
        transform: translate(-45%, -45%) scale(1);
        z-index: 2;

        &:nth-child(2) {
            animation-delay: 0.3s;
            top: 68%;
        }

        @media (max-width: 576px) {
            &:nth-child(2) {
                top: 70%;
            }
        }
    }

    .card-bg-img-triple {
        left: 50%;
        position: absolute;
        top: 26%;
        transform: translate(-45%, -45%) scale(1);
        z-index: 2;

        &:nth-child(2) {
            animation-delay: 0.3s;
            top: 53%;
        }

        @media (max-width: 576px) {
            &:nth-child(2) {
                top: 80%;
            }
        }
    }
}
.corgiwild-wrapper-card-win {
    border: 2px solid rgba(147, 111, 255, 0.5);

    .card-help-bg {
        &::after {
            animation: lines-wild-roll 6s linear infinite;
            background-image: url(@/assets/imgs/casino/corgiwild/lines-wild-win.webp);
            z-index: 1;
        }
    }
    .card-wild-text {
        .card-wild-text-img {
            animation: pulse-wild-text 2s linear infinite;
        }
    }
    .card-wild-img {
        background: #380d0094;
    }
}
.board-no-animation .corgiwild-wrapper-card-win {
    .card-bg {
        &::after {
            animation: none !important;
        }
        img {
            animation: none !important;
        }
    }
}
.corgiwild-wrapper-card-win .card-bg {
    background: #00000094;

    .card-bg-img,
    .card-double-img,
    .card-triple-img {
        animation: pulse-win 1s linear infinite;
    }
    &::after {
        animation: lines-roll 6s linear infinite;
        background-image: url(@/assets/imgs/casino/corgiwild/lines-bg.webp);
        content: '';
        height: 132px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%) rotate(0);
        width: 132px;
    }
}
@keyframes pulse-win {
    0% {
        transform: translate(-45%, -45%) scale(1);
    }

    50% {
        transform: translate(-45%, -45%) scale(1.05);
    }

    to {
        transform: translate(-45%, -45%) scale(1);
    }
}
@keyframes pulse-wild-text {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    to {
        transform: scale(1);
    }
}
@keyframes lines-roll {
    0% {
        transform: translate(-50%, -50%) rotate(0);
    }

    to {
        transform: translate(-50%, -50%) rotate(1turn);
    }
}
@keyframes lines-wild-roll {
    0% {
        transform: translate(-50%, -70%) rotate(0);
    }

    to {
        transform: translate(-50%, -70%) rotate(1turn);
    }
}
</style>./7.vue./wild.vue./single.vue./double.vue./triple.vue./cherry.vue